import { colors } from "./colors";

// Ombres — port web.
//
// Sur natif, chaque niveau existait en DEUX déclinaisons irréconciliables :
// iOS (shadowColor/Opacity/Radius/Offset) et Android (`elevation`, un simple
// entier que le système traduit en ombre). D'où le `Platform.select`.
//
// Le web n'a qu'un modèle, `box-shadow`, plus expressif que les deux : on part
// donc des valeurs iOS, qui portaient l'intention de design, et Android
// disparaît. Les rayons Android étaient de toute façon une approximation.
//
// Les tokens sont des CHAÎNES CSS prêtes à poser dans `style={{ boxShadow }}`
// ou dans une classe. Les valeurs iOS (opacité, rayon, offset) sont reprises à
// l'identique.

const navy = colors.navy800; // #0b1220

/** rgba() depuis un hex — les ombres ont besoin d'une opacité, pas d'un hex. */
function alpha(hex: string, opacity: number): string {
  const n = parseInt(hex.slice(1), 16);
  const r = (n >> 16) & 255;
  const g = (n >> 8) & 255;
  const b = n & 255;
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

export const shadow = {
  // sh-1 — élévation légère (cards en surface)
  sh1: `0 2px 6px ${alpha(navy, 0.05)}`,

  // sh-2 — élévation moyenne (modals, bottom sheets)
  sh2: `0 8px 24px ${alpha(navy, 0.08)}`,

  // sh-3 — élévation haute (overlays, drawers)
  sh3: `0 16px 48px ${alpha(navy, 0.12)}`,

  // sh-sos — halo rouge urgence (FAB SOS)
  sos: `0 6px 20px ${alpha(colors.sos600, 0.38)}`,
} as const;

export type ShadowToken = keyof typeof shadow;
